import React from 'react';

// Component
import TableFare from './TableFare';
import { Box } from '@mui/system';

function Section13(props: any) {
  const {
    selectedDate, flightData, handleSelectTrip, airline, hideAirline,
  } = props;
  return (
    <Box sx={{
      background: '#FFFFFF',
      boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
      borderRadius: '6px',
      marginTop: '1em',
    }}
    >
      <TableFare
        selectedDate={selectedDate}
        flightData={flightData}
        onSelectTrip={handleSelectTrip}
        airline={airline}
        hideAirline={hideAirline}
      />
    </Box>
  );
}

export default React.memo(Section13);
